
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"2 min read","minutes":1.02,"time":61200,"words":204}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Capturing Local Kitchen Stories`}</p>
    {
      /*-
      <img
       src="burger.jpg"
       alt="CamDely Magazine"
      />*/
    }
    <p>{` `}<a parentName="p" {...{
        "href": "/"
      }}>{`dolor amet hell`}</a>{` I believe you must bring your whole self to the table if you want to thrive in today’s crazy world; your
personality, your sense of humor, and most importantly, your heart. As Indians, we’ve always known the best way to our heart was from our
belly. So CamDely brings you a weekly local guide to help you find the right way to your heart or to the heart of someone you love. Every
Thursday, we tell you of a new place to hangout with your friends, a new place to date someone, a new place to visit with your family and most
importantly a new place for foodies to be excited about. We make sure, where there’s food, there’s hygiene too. `}</p>
    <p>{`Stay updated with us by following us on Instagram, Facebook, Pinterest for some exclusive food tips and content. We’re also rolling out exciting, deals, offers and contests for you to participate in as we go along from place to place.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "slug": "CamDely",
  "title": "CamDely Magazine",
  "description": "Capturing Local Delicacies",
  "banner": "anim.gif",
  "bannerPlaceholder": "burger.jpg",
  "bannerAlt": "Burger shot by Team CamDely",
  "tags": [
    "camdely",
    "camdely magazine",
    "quadato"
  ],
  "date": "2019-10-29T00:00:00.000Z",
  "readTime": "00:01:00:00"
}

